/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

import {
  Component, EventEmitter, Inject, Input, Output,
} from '@angular/core';
import { ButtonStyle } from '../../aero/aero-button/aero-button.component';

/**
 * Angular component that handles adding a logo in resume subsections.
 */
@Component({
  selector: 'bulb-resume-sub-section-logo',
  templateUrl: './logo-upload.component.html',
  styleUrls: ['./logo-upload.component.scss'],
  standalone: false,
})
export class LogoUploadComponent {
  /**
   * Uploaded logo url.
   */
  @Input()
  public logoUrl: string;

  /**
   * Alternate text for images.
   */
  @Input()
  public altText: string;

  /**
   * Button style and type.
   */
  public buttonStyle: ButtonStyle = ButtonStyle.TEXT_WITH_ICON;

  /**
   * Event emitter for when the user clicks on delete logo button.
   */
  @Output()
  public delete: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Event emitter for when the upload completes.
   */
  @Output()
  public uploadComplete: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Default constructor.
   *
   * @param bulbModalService
   */
  constructor(
    @Inject('BulbModalService') private bulbModalService,
  ) {}

  /**
   * Method to show delete logo confirmation modal.
   */
  deleteLogo() {
    this.bulbModalService.show({
      titleCode: 'resume_delete_logo_image',
      bodyCode: 'resume_delete_logo_image_body',
      okButtonCode: 'button_delete',
      cancelButtonCode: 'button_cancel',
      fontAwesomeCode: 'far fa-trash-alt',
      windowClass: 'updated-modal-design bulb-aero-modal bulb-delete-logo-confirmation',
    }).then(() => {
      this.delete.emit();
    });
  }

  /**
   * Method called when the upload is complete.
   * @param url
   */
  onUploadComplete(url) {
    this.logoUrl = url;
    this.uploadComplete.emit(url);
  }
}
